module.exports = __webpack_public_path__ + "static/media/F2.7884bc0c.png";